import { useMemo } from 'react';
import { ExtendedLocation } from './ExtendedLocation.model';
import { ISelectOptions } from '~/Models/interfaces/SelectOption.models';
import { useRequestCitiesCountries } from '~/requests';

export const useCountries = (location?: ExtendedLocation) => {
  const isAddress = useMemo(
    () => location?.street || location?.zipCode || location?.city || location?.countryISOA2,
    [location],
  );

  const isValidAddress = useMemo(
    () => location?.street && location?.zipCode && location?.city && location?.countryISOA2,
    [location],
  );

  const { data: countryList = [] } = useRequestCitiesCountries({});

  const countries = useMemo<ISelectOptions>(() => {
    const countryOptions = [] as ISelectOptions;
    const length = countryList.length;
    if (length > 0) {
      for (let index = 0; index < length; index++) {
        const country = countryList[index];
        if (country === null || country === undefined) {
          continue;
        }
        countryOptions.push({
          label: country?.name,
          value: country?.code,
        });
      }
    }
    return countryOptions;
  }, [countryList]);

  return {
    countries,
    isAddress,
    isValidAddress,
  };
};
